<template>
    <button
        @click="showModal(house, time, avaliableDuration)"
        class="block w-full text-left px-4 py-2 border-b text-gray-700"
        :disabled="!isAvaliable"
        :class="{
            'bg-white border-gray-200 hover:bg-green-100 hover:border-green-200 hover:text-green-900': isAvaliable,
            'cursor-default bg-red-100 border-red-200': !isAvaliable
        }"
    >
        <div class="flex justify-between items-center h-10">
            <div class="relative">
                <div class="absolute px-2 bg-white text-xs text-gray-800 leading-normal rounded-r left-0" style="top: 0px; transform: translate(-16px, -210%)">
                    {{ moment(time, "HH:mm:ss").format("H:mm") }}
                </div>
                <div class="absolute px-2 bg-white text-xs text-gray-800 leading-normal rounded-r left-0" style="bottom: 0px; transform: translate(-16px, 215%)">
                    {{ moment(time, "HH:mm:ss").add('30', 'minutes').format("H:mm") }}
                </div>
            </div>
            <div
                class="bg-green-200 text-xs rounded text-green-700 px-2 py-1"
                v-if="isAvaliable"
            >
                rezervovat
            </div>
            <div class="text-xs rounded text-red-300 px-2 py-1" v-else>
                rezervováno
            </div>
        </div>
    </button>
</template>

<script>
import moment from 'moment'
export default {
    props: ['house', 'time', 'reservations', 'last'],
    data() {
        return {
            format: 'HH:mm:ss'
        }
    },
    computed: {
        isAvaliable() {
            return this.checkTimes(moment(this.time, this.format))
        },
        avaliableDuration() {
            return this.checkTimes(
                moment(this.time, this.format).add(30, 'minutes')
            ) && !this.last
                ? '01:00:00'
                : '00:30:00'
        }
    },
    methods: {
        moment,
        showModal(house, time, avaliableDuration) {
            this.$root.$emit('showModal', { house, time, avaliableDuration })
        },
        checkTimes(time) {
            let x = this.reservations.filter(reservation => {
                let beforeTime = moment(reservation.time, this.format),
                    afterTime = moment(reservation.to, this.format)
                return (
                    time.isBetween(beforeTime, afterTime) ||
                    time.isSame(beforeTime)
                )
            })
            return !Boolean(x.length)
        }
    }
}
</script>
